<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && allScene.length===0">{{ $t('scene.no_scene_available_hint') }}</span>

  <span class="centerized title grey--text text-xs-center" v-else-if="!loading && filteredScene.length===0">{{ $t('scene.no_scene_matched') }}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xs12 sm6 md4 lg3 xl2 v-for="item in filteredScene" :key="item.key">
      <scene-item :item="item" @click="onSceneClicked"></scene-item>
    </v-flex>
  </v-layout>

  <scene-creator v-if="dialogCreator" v-model="dialogCreator" @create="onSceneCreated"></scene-creator>

  <scene-editor v-if="dialogEditor" v-model="dialogEditor" :data="dialogEditorData" @enable="enableScene" @toast="val=>$emit('toast',val)"></scene-editor>

  <v-btn color="secondary" dark fixed bottom right fab @click="dialogCreator=true" v-if="!loading">
    <v-icon>add</v-icon>
  </v-btn>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import SceneItem from './SceneItem'
import SceneEditorDialog from './SceneEditorDialog'
import SceneCreatorDialog from './SceneCreatorDialog'

export default {
  name: 'Scene',
  mixins: [UserAuth],
  components: {
    'scene-item': SceneItem,
    'scene-editor': SceneEditorDialog,
    'scene-creator': SceneCreatorDialog
  },
  data() {
    return {
      dialogEditor: false,
      dialogEditorData: null,
      dialogCreator: false
    }
  },
  computed: {
    loading() {
      return this.sceneLoading;
    },
    allScene() {
      let list = [];
      Object.keys(this.userScene).forEach(mac => {
        Object.values(this.userScene[mac]).forEach(s => {
          list.push({
            key: mac + s.title,
            mac: mac,
            ...s
          });
        });
      });
      return list.sort((a, b) => a.key.localeCompare(b.key));
    },
    filteredScene() {
      let data = this.allScene;
      if (data) {
        if (this.searchGateway && this.searchGateway.length > 0)
          data = data.filter(item => item.mac === this.searchGateway);

        if (this.searchKeyword && this.searchKeyword.length > 0)
          data = data.filter(item => item.title.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) != -1);
      }
      return data;
    }
  },
  methods: {
    onSceneClicked(item) {
      this.dialogEditorData = item;
      this.dialogEditor = true;
    },
    onSceneCreated(key) {
      this.dialogEditorData = this.allScene.find(s => s.key == key);
      this.dialogEditor = true;
    },
    async enableScene(item) {
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          mac: item.mac,
          cmd: 'doscene',
          val: item.title
        });
      } catch (err) {
        this.$emit('toast', this.$t('scene.permission_denied'));
        return;
      }
      this.$emit('toast', this.$t('scene.enable_scene', {
        name: item.title,
        mac: (this.userMacInfo[item.mac] || {}).hostname || item.mac
      }));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/scene/Scene.vue